import React from "react";
import { Link } from "react-router-dom";
import Banner from "./Banner";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const fuddLore = [
  "Make sure to let the gun cool off between clips so the rounds don't cook off.",
  "If the temperature's below zero stagger hollow-point and full metal jacket.",
  "Don't worry about bad groups at close range, the projectile will settle out by 300 yards.",
  "Nobody needs more than 8 rounds.",
  "Listen here son, you need a .45 ACP for real stopping power.",
  "Polymer guns are prone to heat warping.",
  "You can't use a 5.56, it'll ruin the meat.",
  "AR15s are a paperclip away from full auto."
];

function NotFoundPage() {
  var index = Math.floor(Math.random() * fuddLore.length)
  var lore = fuddLore[index]

  index += (3 * Math.floor(Math.random() * fuddLore.length) + 1)

  return (
    <div>
      <Banner authState="notFound" />
      <Box sx={{ margin: "50px 15px", display: "block", textAlign: "center" }}>
        <Typography variant="h4" component="h3" gutterBottom>Page Not Found</Typography>
        <Typography
          variant="h6"
          component="h4"
          gutterBottom
          sx={{
            maxWidth: "500px",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "5%",
            fontWeight: 400,
          }}
        >
          Fudd Lore #{index}: &quot;{lore}&quot;
        </Typography>
        <Link to="/">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<ArrowBackIcon />}
          >
            Go Home
          </Button>
        </Link>
      </Box>
    </div>
  );
}

export default NotFoundPage;
